import { inject } from "@angular/core";
import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { I18nService } from "../i18n/i18n.service";

export function localeInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const i18n = inject(I18nService);

  return next(req.clone({ setHeaders: { "X-Locale": i18n.language() } }));
}
